import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default class SeamlessStats extends Component {
	leftWidth(t1, t2) {
		if (t1 == t2)
			return 50; //50%
		return 0.1 + (100 * (t1) / (t1 + t2));
	}
	nameFormatter(name) {
		return (name || "").replace(/_/g, " ");
	}
	addIfDontExists(stats, sport) {
		if (sport != '/sport/1') {
			return stats;
		}
		let obj = {
			dangerous_attack: { team1_value: 0, team2_value: 0 },
			shot_on_target: { team1_value: 0, team2_value: 0 },
			shot_off_target: { team1_value: 0, team2_value: 0 },
			corner: { team1_value: 0, team2_value: 0 },
			yellow_card: { team1_value: 0, team2_value: 0 },
			red_card: { team1_value: 0, team2_value: 0 },
		};
		return { ...obj, ...stats };
	}
	isHidden(sportId, stat) {
		if (!HIDE[sportId])
			return false;
		return HIDE[sportId].has(stat)
	}
	render({ event }) {
		return (
			<div class={"live-game-stats stats-"}>
				{event.misc.stats &&
					Object.entries(this.addIfDontExists(event.misc.stats, event.sport))
						.filter(([name]) => name.indexOf("score_") != 0 && !this.isHidden(event.sport, name))
						.map(([name, { team1_value, team2_value }]) => (
							<div class="statistic-view-m" key={name}>
								<p style="text-transform: capitalize;">
									{window.Translation(this.nameFormatter(name))}
								</p>
								<div class="statistic-line-view">
									<span style={{ width: this.leftWidth(team1_value, team2_value) + "%" }}>
										<i>{team1_value || 0}</i>
									</span>
									<span>
										<i>{team2_value || 0}</i>
									</span>
								</div>
							</div>
						))}
			</div>
		);
	}
}

const HIDE = {
	'/sport/1': new Set([
		"penalty",
		"offside",
		"substitution",
		"foul",
		"goal",
		"passes",
		"goal_kick",
		"ballSafe",
		"kick_off",
		"injury_break",
		"attack",
		"goalkeeper_save",
		"throw_in",
		"free_kick",
	]),
	// Come lo spieghi a klodi che queste info non sono raggiungibili perché cyberfootball non è un id?
	cyberfootball: new Set([
		"penalty",
		"offside",
		"substitution",
		"foul",
		"goal",
		"passes",
		"goal_kick",
		"ballSafe",
		"kick_off",
		"injury_break",
		"attack",
		"goalkeeper_save",
		"throw_in",
		"free_kick",
	]),
	// 4: ["aces", "double_fault"].reduce((c, row) => ({ ...c, [row]: true }), {})
};


/**
 * Non so come mai klodi le abbia create e lasciate così. 
 * Comunque le riutilizzo in maniera "creativa" e faccio in modo 
 * di usarle per estrarre le traduzioni
 */
export const translations = [
	msg`dangerous attack`,
	msg`shot on target`,
	msg`shot off target`,
	msg`corner`,
	msg`penalty`,
	msg`offside`,
	msg`substitution`,
	msg`foul`,
	msg`goal`,
	msg`passes`,
	msg`goal kick`,
	msg`ballSafe`,
	msg`kick off`,
	msg`injury break`,
	msg`attack`,
	msg`goalkeeper save`,
	msg`throw in`,
	msg`free kick`,
	msg`red card`,
	msg`set`,
	msg`yellow card`,
	msg`yellow card set2`,
	msg`yellow card set1`,
	msg`corner set1`,
	msg`score`,
	msg`red card set2`,
	msg`yellowcard`,
	msg`red card set1`,
	msg`redcard`,
	msg`red card`,
	msg`corner set2`,
];
